import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import validateReCaptcha from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ValidateReCaptcha";
import translate from "@insite/client-framework/Translate";
import ReCaptcha from "@insite/content-library/Components/ReCaptcha";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupComponentProps } from "@insite/mobius/CheckboxGroup";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { AddPunchoutSecret } from "@TKCCP/Store/Data/PunchoutSecretService/Handlers/AddPunchoutServiceHandler";
import loadPunchouts from "@TKCCP/Store/Data/PunchoutSecretService/Handlers/LoadPunchoutSecretHandler";
import { getPunchoutDataView } from "@TKCCP/Store/Data/PunchoutSecretService/PunchoutSecretServiceSelector";
import ApplicationStateTKCCP from "@TKCCP/Store/TKCCPState";
import { PunchoutServiceModel } from "@TKCCP/Types/ApiModels";
import * as React from "react";
import { RefObject } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    text?: string;
    extendedStyles?: ProductShareLinkStyles;
    editComapny: string;
    editIsActive: boolean;
    editSharedSecret: string;
    editId: string;
    editModalIsOpen: boolean;
    handleClose(): void;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const mapStateToProps = (state: ApplicationStateTKCCP) => ({
    session: state.context.session,
    punchoutDataView: getPunchoutDataView(state, state.pagePunchoutSecret.getPunchoutParameter),
    getPunchoutParameter: state.pagePunchoutSecret.getPunchoutParameter,
});

const mapDispatchToProps = {
    AddPunchoutSecret,
    validateReCaptcha: makeHandlerChainAwaitable<
        { location: string; recaptchaRef: RefObject<ReCAPTCHA | null> },
        boolean
    >(validateReCaptcha),
    loadPunchouts,
};

export interface ProductShareLinkStyles {
    link?: LinkPresentationProps;
    modal?: ModalPresentationProps;
    container?: GridContainerProps;
    recipientNameGridItem?: GridItemProps;
    recipientNameTextField?: TextFieldProps;
    recipientEmailGridItem?: GridItemProps;
    recipientEmailTextField?: TextFieldProps;
    yourNameGridItem?: GridItemProps;
    yourNameTextField?: TextFieldProps;
    yourEmailGridItem?: GridItemProps;
    yourEmailTextField?: TextFieldProps;
    yourMessageGridItem?: GridItemProps;
    yourMessageTextArea?: TextAreaProps;
    reCaptchaGridItem?: GridItemProps;
    buttonsWrapper?: InjectableCss;
    cancelButton?: ButtonPresentationProps;
    shareButton?: ButtonPresentationProps;
    isActiveCheckboxGroup: CheckboxGroupComponentProps;
    isActiveCheckbox: CheckboxProps;
    generateBtnGridItem?: GridItemProps;
    generateKeyButton?: InjectableCss;
    productShareLink?: InjectableCss;
}

export const productShareLinkStyles: ProductShareLinkStyles = {
    modal: {
        size: 600,
        cssOverrides: {
            modalTitle: css`
                padding: 20px 30px;
            `,
        },
    },
    productShareLink: {
        css: css`
            margin-top: 20px;
            margin-bottom: 20px;
        `,
    },
    container: { gap: 10 },
    recipientNameGridItem: {
        width: [6, 7, 7, 7, 7],
        css: css`
            padding-right: 5px;
        `,
    },
    recipientEmailGridItem: {
        width: [6, 7, 7, 7, 7],
        css: css`
            padding-left: 5px;
        `,
    },
    generateBtnGridItem: {
        width: [6, 5, 5, 5, 5],
        css: css`
            padding-left: 10px;
            align-items: end;
        `,
    },
    yourNameGridItem: {
        width: [6, 7, 7, 7, 7],
        css: css`
            padding-right: 5px;
        `,
    },
    yourEmailGridItem: {
        width: 12,
        css: css`
            padding-left: 5px;
            label {
                line-height: 18px;
                margin-top: 1px;
            }
        `,
    },
    yourMessageGridItem: {
        width: 12,
    },
    yourMessageTextArea: {
        cssOverrides: {
            inputSelect: css`
                resize: none;
            `,
        },
    },
    reCaptchaGridItem: {
        width: 12,
    },
    buttonsWrapper: {
        css: css`
            margin-top: 30px;
            text-align: right;
        `,
    },
    cancelButton: {
        variant: "secondary",
    },
    shareButton: {
        css: css`
            margin-left: 10px;
        `,
    },
    isActiveCheckbox: {
        typographyProps: {
            css: css`
                margin-left: 10px;
            `,
        },
    },
    isActiveCheckboxGroup: {},
};

const EditPunchoutModal = ({
    validateReCaptcha,
    text,
    extendedStyles,
    getPunchoutParameter,
    loadPunchouts,
    editComapny,
    editIsActive,
    editSharedSecret,
    editId,
    editModalIsOpen,
    handleClose,
}: Props) => {
    const toasterContext = React.useContext(ToasterContext);
    const [styles] = React.useState(() => mergeToNew(productShareLinkStyles, extendedStyles));
    const recaptchaRef: RefObject<ReCAPTCHA | null> = React.createRef();
    const [modalIsOpen, setModalIsOpen] = React.useState(false);

    const [company, setCompany] = React.useState("");
    const [companyError, setCompanyError] = React.useState("");

    const [sharedSecret, setsharedSecret] = React.useState("");
    const [sharedSecretError, setsharedSecretError] = React.useState("");
    const disablesecretKey = true;
    const [isActive, setisActive] = React.useState(editIsActive);
    const [inProgress, setInProgress] = React.useState(false);

    React.useEffect(() => {
        setCompany(editComapny);
        setsharedSecret(editSharedSecret);
        setisActive(editIsActive);
    }, [editComapny, editSharedSecret, editIsActive]);

    const modalCloseHandler = () => {
        setModalIsOpen(false);
        editModalIsOpen = false;
    };

    const shareLinkClickHandler = () => {
        resetFields();
        setModalIsOpen(true);
        setsharedSecret(editSharedSecret);
        setCompany(editComapny);
        setisActive(editIsActive);
    };

    const requiredFieldMessage = translate("This is a required field");
    const checkForErrors = () => {
        const localCompanyErrorMessage = !company ? requiredFieldMessage : "";
        setCompanyError(localCompanyErrorMessage);

        const localSharedSecretErrorMessage = !sharedSecret ? requiredFieldMessage : "";
        setsharedSecretError(localSharedSecretErrorMessage);

        return !!(localCompanyErrorMessage || localSharedSecretErrorMessage);
    };

    const resetFields = () => {
        setCompany("");
        setsharedSecret("");
        setCompanyError("");
        setsharedSecretError("");
        setisActive(false);
        setInProgress(false);
    };

    const PunchoutActivehandler: CheckboxProps["onChange"] = (_, value) => {
        setisActive(value);
    };

    const companyChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCompany(event.target.value);
        setCompanyError(!event.target.value ? requiredFieldMessage : "");
    };
    const sharedSecretChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setsharedSecretError(!event.target.value ? requiredFieldMessage : "");
    };

    const addButtonClickHandler = async () => {
        if (checkForErrors()) {
            return;
        }
        const isReCaptchaValid = await validateReCaptcha({ location: "ShareProduct", recaptchaRef });
        if (!isReCaptchaValid) {
            return;
        }
        handleClose();
        const punchoutParameter = {} as PunchoutServiceModel;
        setInProgress(true);

        AddPunchoutSecret({
            punchoutmodel: {
                company,
                isActive,
                sharedSecret,
                uri: punchoutParameter.uri,
                properties: punchoutParameter.properties,
                id: editId,
            },
        });
        loadPunchouts(getPunchoutParameter);
    };

    return (
        <>
            <Modal
                {...styles.modal}
                headline={translate("Edit Punchout")}
                isOpen={editModalIsOpen}
                handleClose={handleClose}
                onClick={shareLinkClickHandler}
            >
                <GridContainer {...styles.container} data-test-selector="punchoutSecretModal">
                    <GridItem {...styles.recipientNameGridItem}>
                        <TextField
                            label={translate("Company")}
                            value={company}
                            error={companyError}
                            onChange={companyChangeHandler}
                            data-test-selector="punchoutSecretCompany"
                            {...styles.recipientNameTextField}
                        />
                    </GridItem>
                    <GridItem {...styles.recipientEmailGridItem}>
                        <TextField
                            label={translate("Shared Secret")}
                            value={sharedSecret}
                            error={sharedSecretError}
                            disabled={disablesecretKey}
                            onChange={sharedSecretChangeHandler}
                            data-test-selector="punchoutSharedSecret"
                            {...styles.recipientEmailTextField}
                        />
                    </GridItem>
                    <GridItem {...styles.yourEmailGridItem}>
                        <CheckboxGroup {...styles.isActiveCheckboxGroup}>
                            <Checkbox
                                {...styles.isActiveCheckbox}
                                onChange={PunchoutActivehandler}
                                checked={isActive}
                                data-test-selector="isActivePunchout"
                            >
                                {translate("Active")}
                            </Checkbox>
                        </CheckboxGroup>
                    </GridItem>

                    <GridItem {...styles.reCaptchaGridItem}>
                        <ReCaptcha location="ShareProduct" recaptchaRef={recaptchaRef} />
                    </GridItem>
                </GridContainer>
                <StyledWrapper {...styles.buttonsWrapper}>
                    <Button {...styles.cancelButton} onClick={handleClose} data-test-selector="productShareCancel">
                        {translate("Cancel")}
                    </Button>
                    <Button
                        {...styles.shareButton}
                        onClick={addButtonClickHandler}
                        data-test-selector="productShareSubmit"
                        // disabled={inProgress}
                    >
                        {translate("Save")}
                    </Button>
                </StyledWrapper>
            </Modal>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(EditPunchoutModal);
